import React from 'react';

const PostingOperationPage = React.lazy(() => import('pages/PostingOperation/PostingOperationPage'));
const PostingOperationFormPage = React.lazy(() => import('pages/PostingOperation/PostingOperationFormPage'));

const postingOperation = [
  { path: '/posting-operation', exact: true, name: 'Danh mục nghiệp vụ', function: 'AC_POSTINGOPERATION_VIEW', component: PostingOperationPage },
  { path: '/posting-operation/add', exact: true, name: 'Thêm nghiệp vụ', function: 'AC_POSTINGOPERATION_ADD', component: PostingOperationFormPage },
  { path: '/posting-operation/edit/:code', exact: true, name: 'Chỉnh sửa nghiệp vụ', function: 'AC_POSTINGOPERATION_EDIT', component: PostingOperationFormPage },
  { path: '/posting-operation/detail/:code', exact: true, name: 'Chi tiết nghiệp vụ', function: 'AC_POSTINGOPERATION_VIEW', component: PostingOperationFormPage },
];

export default postingOperation;
